import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);

  canActivate(): boolean | Observable<boolean | UrlTree> | UrlTree {
    return this.authenticationService.isAuthenticated.pipe(map((isAuth) => !isAuth || this.router.parseUrl('balances')));
  }
}
